module.exports = __webpack_public_path__ + "img/button-home5.3149be28.jpeg";